<template>
  <span style="position: relative;">
    <nav class="gtco-nav" role="navigation" style="background-color: rgba(6, 79, 53, 1);">
      <div id="myDiv" v-show="btnFlag" class="row header-logo collapse-transition" style="background-color: #ffffff;padding: 30px 0;">
        <div class="col-md-12 col-sm-12 col-xs-12 text-center header-center-bg">
          <div>
            <img src="/static/img/home/home-logo@2x.png" style="width:120px;height: 120px;"/>
            <h2 style="font-size: 30px;margin-top: 40px;">无名碳链(指数)平台</h2>
            <h2 style="font-size: 30px;margin-top: 40px;">香港無名碳鏈技術有限公司</h2>
          </div>
        </div>
      </div>
      <div class="gtco-container" style="height: 80px;line-height: 80px;">
        <div class="row">
          <div class="col-sm-2 col-xs-12">
            <div id="gtco-logo"><a href="index.html"><img src="/static/img/logo.png" class="logo" style="width: 52px;height: 52px;"/></a></div>
          </div>
          <div class="col-xs-8 col-sm-10 text-right menu-1">
            <ul>
              <li :class="hasHover('index')?'active':''"><a href="/index">首页</a></li>
              <li  :class="hasHover('resources')?'active':''"><a href="/resources/index">厨房零(近零碳)供应链</a></li>
              <li class="has-dropdown"  :class="hasHover('3060')?'active':''">
                <a href="/3060/menu3060_1">关于双碳</a>
                <ul class="dropdown">
                  <li><a href="/3060/menu3060_1">国家各部委政策</a></li>
                  <li><a href="/3060/menu3060_2">国家部委碳足迹</a></li>
                  <li><a href="/3060/menu3060_3">各省市双碳政策</a></li>
                </ul>
              </li>
              <li :class="hasHover('menu1')?'active':''" class="has-dropdown">
                <a  href="#">碳标签</a>
                <ul class="dropdown">
                  <li><a href="/biaoqian/menu1?active=标准制定">标准制定</a></li>
                  <li><a href="/biaoqian/menu1?active=标准化要闻">标准化要闻</a></li>
                  <li><a href="/biaoqian/menu1_1?active=低碳产品声明">低碳产品声明</a></li>
                  <li><a href="/biaoqian/menu1_2?active=碳标签评价">碳标签评价</a></li>
                </ul>
              </li>
              <li :class="hasHover('resources')?'aboutUs':''"><a href="/aboutUs/index">联系我们</a></li>
              <li><a target="_blank" href="https://wmiot.sslunion.com/shuangQiangGroup/bigScreen">商厨指数平台</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div id="mobile-nav" style="position: sticky;position: -webkit-sticky;z-index: 999;"></div>
  </span>
</template>

<script>
  import Jquery from 'jquery'
export default {
  props:['showHeader'],
  name: "GlobalHeader",
  data () {
    return {
      btnFlag: false,
      activeName:'',
    };
  },
  mounted () {
    this.$nextTick(()=>{
      new this.$wow.WOW().init()
      this.activeName = this.$route.name
    })
    console.log("this.activeMenu",this.activeMenu)
    // window.addEventListener('scroll', this.handleScroll);
    if (this.$route.name=='index'){
      this.btnFlag = true;
      setTimeout(()=>{
        let $div1=Jquery('.header-logo')
        $div1.fadeOut(2000,function(){
        });
      },2000)
    }else{
      this.btnFlag = false;
    }

  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    // window.removeEventListener("scroll", this.scrollToTop, true);
  },
  watch:{

  },
  methods: {
    scrollToTop () {
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 50) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    handleScroll() {
      // 处理滚动事件
      console.log(window.scrollY); // 输出当前滚动位置
      if (window.scrollY>10){
        this.btnFlag = true;

      } else {
        this.btnFlag = false;
      }
    },
    hasHover(value){
      console.log("this.activeName",this.activeName)
      return typeof this.activeName!='undefined'?this.activeName.indexOf(value)>-1?true:false:false
    }
  },
};
</script>

<style lang="less" >
  .header-center-bg{
    background-image: url("/static/img/home/bgline.png");
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    height: 350px;
    display: flex;align-items: center;justify-content: center;
  }

 .collapse-transition{
   transition: width 2s, height 2s; /* 设置过渡效果 */
   overflow: hidden; /* 隐藏超出部分 */
 }

</style>
